import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cdc',
  templateUrl: './cdc.component.html',
  styleUrls: ['./cdc.component.scss']
})
export class CdcComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
